import { Box, Flex, Text, Heading } from '@radix-ui/themes';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <Flex direction="column" align="center" justify="center" gap="4" p="6">
            <Heading size="8" mb="2">404</Heading>
            <Text size="5">Page Not Found</Text>
            <Text size="3" color="gray">The page you are looking for doesn't exist or has been moved.</Text>
            <Box mt="4">
                <Link to="/" style={{ color: 'var(--accent-9)', textDecoration: 'none' }}>
                    Return to Homepage
                </Link>
            </Box>
        </Flex>
    );
};

export default NotFound;
